import RequestHandler from "./request-handler";
class HeatingTableService {
    constructor() {
        this.path = "HeatingTable";
        if (HeatingTableService.instance) {
            return HeatingTableService.instance;
        }
        HeatingTableService.instance = this;
        return this;
    }
    async get(id) {
        return await RequestHandler.get(this.path, id);
    }
    async insert(data) {
        return await RequestHandler.post(this.path, data);
    }
    async update(data) {
        return RequestHandler.put(this.path, data);
    }
    async delete(id) {
        return await RequestHandler.delete(this.path, id);
    }
}
const instance = new HeatingTableService();
export default instance;